// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__3P2Cy","item":"styles_item__1rXpR"};